/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QuickquoteIndexRouteImport } from './routes/quickquote/index'
import { Route as QuickquotePrivacyRouteImport } from './routes/quickquote/privacy'
import { Route as QuickquoteTermsRouteImport } from './routes/quickquote/terms'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickquoteIndexRoute = QuickquoteIndexRouteImport.update({
  id: '/quickquote/',
  path: '/quickquote/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickquotePrivacyRoute = QuickquotePrivacyRouteImport.update({
  id: '/quickquote/privacy',
  path: '/quickquote/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickquoteTermsRoute = QuickquoteTermsRouteImport.update({
  id: '/quickquote/terms',
  path: '/quickquote/terms',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/quickquote/privacy': typeof QuickquotePrivacyRoute
  '/quickquote/terms': typeof QuickquoteTermsRoute
  '/quickquote/': typeof QuickquoteIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/quickquote/privacy': typeof QuickquotePrivacyRoute
  '/quickquote/terms': typeof QuickquoteTermsRoute
  '/quickquote': typeof QuickquoteIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/quickquote/privacy': typeof QuickquotePrivacyRoute
  '/quickquote/terms': typeof QuickquoteTermsRoute
  '/quickquote/': typeof QuickquoteIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/quickquote/privacy' | '/quickquote/terms' | '/quickquote/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/quickquote/privacy' | '/quickquote/terms' | '/quickquote'
  id:
    | '__root__'
    | '/'
    | '/quickquote/privacy'
    | '/quickquote/terms'
    | '/quickquote/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  QuickquotePrivacyRoute: typeof QuickquotePrivacyRoute
  QuickquoteTermsRoute: typeof QuickquoteTermsRoute
  QuickquoteIndexRoute: typeof QuickquoteIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quickquote/': {
      id: '/quickquote/'
      path: '/quickquote'
      fullPath: '/quickquote/'
      preLoaderRoute: typeof QuickquoteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quickquote/privacy': {
      id: '/quickquote/privacy'
      path: '/quickquote/privacy'
      fullPath: '/quickquote/privacy'
      preLoaderRoute: typeof QuickquotePrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quickquote/terms': {
      id: '/quickquote/terms'
      path: '/quickquote/terms'
      fullPath: '/quickquote/terms'
      preLoaderRoute: typeof QuickquoteTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  QuickquotePrivacyRoute: QuickquotePrivacyRoute,
  QuickquoteTermsRoute: QuickquoteTermsRoute,
  QuickquoteIndexRoute: QuickquoteIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
